import { useEffect, useState } from 'react'

import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'

import { CheckboxWrapper } from './CheckoutCheckboxes.styles'
import { Checkbox } from '@big-red-group/storefront-common-ui'
import NZRiskDisclosure from '@/components/NZRiskDisclosureStatement'

type CheckoutCheckboxesProps = {
  allowProceedCheckout: React.Dispatch<React.SetStateAction<boolean>>
}

const CheckoutCheckboxes = ({ allowProceedCheckout }: CheckoutCheckboxesProps) => {
  const defaultProperties = useDefaultProperties()
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  const [checkboxChecked, setCheckboxChecked] = useState(false)
  const [isNZRiskModalOpen, setIsNZRiskModalOpen] = useState(false)

  const handleTcsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked)
  }

  useEffect(() => {
    allowProceedCheckout(checkboxChecked)
  }, [checkboxChecked, allowProceedCheckout])

  return (
    <CheckboxWrapper>
      <NZRiskDisclosure isOpen={isNZRiskModalOpen} onClose={() => setIsNZRiskModalOpen(false)} />
      <Checkbox
        name="nzriskdisclosurestatement"
        value={`${checkboxChecked}`}
        checked={checkboxChecked}
        label={
          <span>
            I have read & accept the{' '}
            <span
              onClick={() => setIsNZRiskModalOpen(true)}
              style={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
            >
              Risk Disclosure Statement
            </span>
          </span>
        }
        onChange={handleTcsChange}
      />
    </CheckboxWrapper>
  )
}

export default CheckoutCheckboxes
